import { hashUserId, normalizeRoutePath } from "./sentry-privacy"
import { getSentry, isSentryEnabled } from "./sentry-state"

let platformTag = "unknown"

export function setMonitorPlatform(platform: "appview" | "zalo") {
  platformTag = platform
  const sentry = getSentry()
  if (sentry) {
    sentry.setTag("platform", platform)
  }
}

export function getMonitorPlatform() {
  return platformTag
}

export function setMonitorUser(user: { id: string; segment?: string } | null) {
  const sentry = getSentry()
  if (!sentry) return

  if (!user) {
    sentry.setUser(null)
    return
  }

  sentry.setUser({
    id: hashUserId(user.id),
    segment: user.segment,
  })
}

export function trackRoute(pathname: string) {
  const normalizedPath = normalizeRoutePath(pathname)
  const sentry = getSentry()

  if (sentry) {
    sentry.getCurrentScope().setTag("route", normalizedPath)
  }

  if (!isSentryEnabled()) return

  sentry?.addBreadcrumb({
    category: "navigation",
    message: normalizedPath,
    level: "info",
  })
}
